import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.header',
    defaultMessage: 'Try our Compliance stage',
    description: 'Main heading of the Compliance pitch modal',
  },
  // The app icon is decorative; this labels the eyebrow beside it.
  eyebrow: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.eyebrow',
    defaultMessage: 'COMPLIANCE',
    description: 'Eyebrow label above the main heading',
  },
  heading: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.heading',
    defaultMessage: 'Automate compliance in Hire',
    description: 'Primary benefits heading',
  },
  body: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.body',
    defaultMessage:
      'Eliminate manual document reviews and move faster with built-in Compliance.',
    description: 'Main benefit description text',
  },
  price: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.price',
    defaultMessage: '$100',
    description: 'Pricing amount',
  },
  priceUnit: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.priceUnit',
    defaultMessage: '/1,000 documents',
    description: 'Pricing unit description',
  },
  checkReject: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.checkReject',
    defaultMessage: 'Automatically reject wrong, expired, or blurry documents',
    description: 'Feature highlight: automatic document rejection',
  },
  checkReview: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.checkReview',
    defaultMessage: 'Reduce manual review time with instant checks',
    description: 'Feature highlight: instant document checks',
  },
  checkOcr: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.checkOcr',
    defaultMessage: 'Increase applicant upload speed and accuracy with OCR',
    description: 'Feature highlight: OCR capabilities',
  },
  freeDocuments: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.freeDocuments',
    defaultMessage: 'Includes 1,000 free documents.',
    description: 'Trial offer: free documents included',
  },
  noCommitment: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.noCommitment',
    defaultMessage: 'No commitment required.',
    description: 'Trial offer: no commitment needed',
  },
  startFreeTrial: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.startFreeTrial',
    defaultMessage: 'Start free trial',
    description: 'Primary call-to-action button label',
  },
  discoverCompliance: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.discoverCompliance',
    defaultMessage: 'Discover Compliance',
    description: 'Secondary call-to-action button label',
  },
  previewAlt: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellModal.previewAlt',
    defaultMessage: 'Compliance document review in Hire',
    description: 'Alt text for preview image',
  },
});
